import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import { createRoot } from "react-dom/client";
import SwiperCore from "swiper";
import { Autoplay, Mousewheel, Navigation } from "swiper/modules";
import "swiper/scss/navigation";
import "swiper/scss";
import { App } from "./App";
import { primaryColor } from "./colors";
import "./index.scss";
import analytics, { generalConsentCookie } from "./services/analytics";
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from "@sentry/react";
import { StyleSheetManager } from "styled-components";
import isPropValid from '@emotion/is-prop-valid';

const sentryDsn =
  "https://5218652aaeac4b7facee891633bcb932@o1003589.ingest.sentry.io/4505369341001728";
const googleClientId =
  "263075766438-k5tnqis6s9pe5q2gesmfgksa0oh4nqgi.apps.googleusercontent.com";

Sentry.init({
  dsn: sentryDsn,
});

SwiperCore.use([Autoplay, Navigation, Mousewheel]);

const color = {
  main: primaryColor,
};
const theme = createTheme({
  typography: {
    fontFamily: "Work Sans, sans-serif",
  },
  palette: {
    primary: color,
    secondary: {
      main: "#fff",
      contrastText: color.main,
    },
  },
});

if (document.cookie.indexOf(`${generalConsentCookie}=`) != -1) {
  analytics.enable();
}

function handleFirstTab(e: KeyboardEvent) {
  if (e.key === "Tab") {
    document.body.classList.add("user-is-tabbing");
    window.removeEventListener("keydown", handleFirstTab);
  }
}

window.addEventListener("keydown", handleFirstTab);

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <ThemeProvider theme={theme}>
        <StyleSheetManager shouldForwardProp={isPropValid}>
          <App />
        </StyleSheetManager>
      </ThemeProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
